import { HIDEN_FROM_UI, SETTING_ATTRIBUTE_IDS } from './settings.constants';
import moment from 'moment';

export default function GeneralSettingsController(
  $state,
  $stateParams,
  $scope,
  $rootScope,
  NotificationService,
  UtilService,
  $translate,
  sessionService,
  GeneralSetting,
  generalSettingsService,
  merchantService,
  SETTING_GROUPS,
  DISABLED_SETTINGS,
) {
  const vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.settingsUnits = GeneralSetting.UNITS;
  vm.settingsCodes = GeneralSetting.CODES;
  vm.displayTypes = GeneralSetting.DISPLAY_TYPES;
  vm.hasQuandooManagerRole = sessionService.hasRole('QUANDOO_MANAGER');
  vm.hasSuperAdminRole = sessionService.hasRole('SUPER_ADMIN');
  vm.hasApprovalWritePermission = sessionService.hasPermission('APPROVAL_WRITE');
  vm.isLoading = false;
  vm.init = init;
  vm.saveSettings = saveSettings;
  vm.toggleSetting = toggleSetting;

  vm.merchant = null;
  vm.settings = null;
  vm.settingsBlocks = null;
  vm.originalSettings = null;
  vm.originalTermsAndConditions = null;
  vm.originalSpecialComBoxSetting = GeneralSetting.specialCommunicationBoxDefault;
  vm.specialComBoxSetting = null;

  vm.originalAirRegieToken = null;
  vm.newAirRegiToken = null;
  vm.airReggieSetting = {};
  vm.needRefresh = false;

  vm.newMenuMgntMinGuest = null;
  vm.originalMenuMgntMinGuest = null;

  const listener = $scope.$on('merchant.tab.settings.selected', vm.init);
  $scope.$on('merchant.configuration.updated', vm.init);
  $scope.$on('merchant.tab.areas.updated', loadSettings);

  function init() {
    listener();
    enableLoading();

    merchantService
      .getMerchantById(vm.merchantId)
      .then(setMerchantData)
      .finally(disableLoading);
  }

  function setMerchantData(merchantData) {
    if (!merchantData) {
      return;
    }
    vm.merchant = merchantData.data;
    vm.originalTermsAndConditions = vm.merchant.termsAndConditions;
    loadSettings();
  }

  function loadSettings() {
    const allSettingIds = SETTING_GROUPS.map(function(settingGroup) {
      return settingGroup.ATTRIBUTE_IDS;
    }).reduce(function(a, b) {
      return a.concat(b);
    }, []);

    generalSettingsService
      .getComposedSettings(vm.merchantId, allSettingIds, vm.merchant)
      .then(hideSettingIfNoPermission)
      .then(disableUnavailableSettings)
      .then(copySettingsFromSource)
      .then(convertMinLeadingTime);
  }

  function formatMinutes(valueInMinutes) {
    const totalMinutes = valueInMinutes % 60;
    const totalHours = Math.floor(valueInMinutes / 60);

    const formattedHours = totalHours.toString().padStart(2, '0');
    const formattedMinutes = totalMinutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  function convertToMinutes(valueInHours) {
    const [hours, minutes] = valueInHours.split(':').map(Number);
    return (hours * 60) + minutes;
  }

  function convertMinLeadingTime(settings) {
    const minLeadingTime = settings.filter(function(setting) {
      return setting.code === GeneralSetting.CODES.MIN_LEADING_TIME;
    });
    const valueInMinutes = minLeadingTime[0].value;
    minLeadingTime[0].value = formatMinutes(valueInMinutes);
  }

  function hideSettingIfNoPermission(settings) {
    if (!vm.hasApprovalWritePermission) {
      hideSettingForCodes([GeneralSetting.CODES.DISABLE_GOOGLE_BOOKING_LINK, GeneralSetting.CODES.DISABLE_GOOGLE_BOOKING_INTEGRATION]);
    }
    if (!vm.hasQuandooManagerRole && !vm.hasSuperAdminRole) {
      hideSettingForCodes([GeneralSetting.CODES.CARD_VAULT_STATUS, GeneralSetting.CODES.PRE_ORDER_MENU_ENABLED]);
    }

    function hideSettingForCodes(codes) {
      codes.forEach(code => generalSettingsService.runForFoundSetting(settings, code, setting => (setting.hide = true)));
    }

    return settings;
  }

  function disableUnavailableSettings(settings) {
    if (vm.merchant && !vm.merchant.productIds.length) {
      settings.map(function(setting) {
        setting.disabled = true;
      });
      return settings;
    }
    DISABLED_SETTINGS.map(function(disabledSetting) {
      if (vm.merchant && vm.merchant.productIds.indexOf(disabledSetting.MERCHANT_PRODUCT) !== -1) {
        settings.map(function(setting) {
          if (disabledSetting.ATTRIBUTE_IDS.indexOf(setting.settingAttributeId) !== -1) {
            setting.disabled = true;
          }
        });
      }
    });

    settings = setAirregiSettingIfNotExist(settings);
    return settings;
  }

  function setAirregiSettingIfNotExist(settings) {
    const airRegiExist = settings.some(function(setting) {
      return setting.settingAttributeId === GeneralSetting.airRegiDefaultToken.settingAttributeId;
    });

    if (airRegiExist) {
      generalSettingsService.runForFoundSetting(settings, GeneralSetting.CODES.AIRREGI_INTEGRATION_TOKEN, function(
        airregieIntegrationSetting,
      ) {
        airregieIntegrationSetting.hide = true;
        vm.originalAirRegieToken = airregieIntegrationSetting.value;
        vm.airReggieSetting = airregieIntegrationSetting;
      });
    } else {
      vm.airReggieSetting = GeneralSetting.airRegiDefaultToken;
    }
    settings = setSpecialComBoxSettingIfNotExist(settings);
    return settings;
  }

  function setSpecialComBoxSettingIfNotExist(settings) {
    const specialComBoxExist = settings.some(function(setting) {
      return setting.settingAttributeId === GeneralSetting.specialCommunicationBoxDefault.settingAttributeId;
    });

    if (specialComBoxExist) {
      generalSettingsService.runForFoundSetting(settings, GeneralSetting.CODES.SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL_MESSAGE, function(
        specialComBoxSetting,
      ) {
        specialComBoxSetting.hide = true;
        vm.originalSpecialComBoxSetting = specialComBoxSetting;
        vm.specialComBoxSetting = specialComBoxSetting;
      });
    } else {
      vm.originalSpecialComBoxSetting = GeneralSetting.specialCommunicationBoxDefault;
    }
    settings = setMenuMgntMinGuestSettingIfNotExist(settings);
    return settings;
  }

  function setMenuMgntMinGuestSettingIfNotExist(settings) {
    const menuMgntMinGuestExist = settings.some(function(setting) {
      return setting.settingAttributeId === GeneralSetting.menuMngtMinGuest.settingAttributeId;
    });

    if (menuMgntMinGuestExist) {
      generalSettingsService.runForFoundSetting(settings, GeneralSetting.CODES.PRE_ORDER_GUESTS_MIN_CHECK, function(
        menuMgntMinGuestSetting,
      ) {
        menuMgntMinGuestSetting.hide = true;
        vm.originalMenuMgntMinGuest = menuMgntMinGuestSetting.value;
        vm.menuMgntMinGuestSetting = menuMgntMinGuestSetting;
      });
    } else {
      vm.menuMgntMinGuestSetting = GeneralSetting.menuMngtMinGuest;
    }
    return settings;
  }

  function copySettingsFromSource(settings) {
    if (!settings) {
      return;
    }
    vm.settings = settings;
    vm.originalSettings = angular.copy(vm.settings);
    vm.settingsBlocks = SETTING_GROUPS.map(function(settingGroup) {
      return {
        name: settingGroup.NAME,
        settings: settings.filter(function(setting) {
          if (
            settingGroup.ATTRIBUTE_IDS.indexOf(setting.settingAttributeId) !== -1 &&
            HIDEN_FROM_UI.indexOf(setting.settingAttributeId) === -1
          ) {
            return setting;
          }
        }),
      };
    });
    return settings;
  }

  function saveSettings(settingsForm) {
    let unsavedSettings;

    if (vm.isLoading || !settingsForm.$valid) {
      return;
    }

    unsavedSettings = getChangedSettings();

    if (unsavedSettings.length) {
      enableLoading();
      generalSettingsService
        .updateSettings(vm.merchantId, formatRequestBody(unsavedSettings))
        .then(displayUpdateSuccess)
        .then(reinitSettings)
        .then(disableLoading)
        .catch(displayUpdateError)
        .then(saveTermsAndConditions)
        .finally(refresh);
    } else {
      saveTermsAndConditions();
    }
  }

  function refresh() {
    if (vm.needRefresh) {
      $state.reload();
    }
  }

  function saveTermsAndConditions() {
    const termAndConditionsSetting = GeneralSetting.getByCode(GeneralSetting.CODES.TERMS_AND_CONDITIONS, vm.settings);

    if (
      termAndConditionsSetting.length &&
      termAndConditionsSetting[0].value &&
      vm.merchant.termsAndConditions !== vm.originalTermsAndConditions
    ) {
      enableLoading();
      merchantService
        .updateMerchant(vm.merchantId, vm.merchant)
        .then(function() {
          NotificationService.success('Terms and Conditions were updated');
        })
        .catch(displayUpdateError)
        .finally(disableLoading);
    }
  }

  function reinitSettings() {
    copySettingsFromSource(vm.settings);
    $rootScope.$broadcast('merchant.settings.updated');
  }

  function toggleSetting(setting) {
    const oldValue = setting.value;
    setting.value = setting.oldValue != null ? setting.oldValue : setting.value ? 0 : 1; // null or undefined
    setting.oldValue = oldValue;

    if (setting.code === GeneralSetting.CODES.OVERBOOKING) {
      toggleOverbookingAreas(setting.value);
    }

    if (setting.code === GeneralSetting.CODES.SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL) {
      vm.textIsRequired = setting.value === 1;
    }
  }

  function toggleOverbookingAreas(overbookingValue) {
    const overbookingAreas = GeneralSetting.getByCode(GeneralSetting.CODES.OVERBOOKING_AREA, vm.settings);
    let i, len;

    if (overbookingAreas.length) {
      for (i = 0, len = overbookingAreas.length; i < len; i = i + 1) {
        if (overbookingValue === 1) {
          overbookingAreas[i].oldValue = 0;
          overbookingAreas[i].value = overbookingAreas[i].id;
        } else {
          overbookingAreas[i].oldValue = overbookingAreas[i].id;
          overbookingAreas[i].value = 0;
        }
      }
    }
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }

  function getChangedSettings() {
    let changedSettings = vm.settings.filter(isDifferentFromOriginal);
    const changedAreaSettings = GeneralSetting.spliceByCode(GeneralSetting.CODES.OVERBOOKING_AREA, changedSettings);
    const activeAreaSettings = GeneralSetting.getByCode(GeneralSetting.CODES.OVERBOOKING_AREA, vm.settings).filter(
      isSelectedOverbookingArea,
    );
    const selectedAreaSettings = changedAreaSettings.filter(isSelectedOverbookingArea);
    const overbookingSettings = GeneralSetting.getByCode(GeneralSetting.CODES.OVERBOOKING, changedSettings);
    const minLeadingTimeSettings = changedSettings.filter(function(setting) {
      return setting.code === GeneralSetting.CODES.MIN_LEADING_TIME;
    });

    if (changedAreaSettings.length) {
      // we only want to submit selected areas
      changedSettings = addOverbookingSettingToSubmit(changedSettings, selectedAreaSettings, activeAreaSettings, overbookingSettings);
    }

    if (!activeAreaSettings.length) {
      // reset overbooking
      vm.needRefresh = true;
      changedSettings = resetOverbookingSetting(changedSettings, overbookingSettings);
    }

    if (minLeadingTimeSettings.length === 1) {
      const valueInHours = minLeadingTimeSettings[0].value;
      minLeadingTimeSettings[0].value = convertToMinutes(valueInHours);
    }

    if (vm.newAirRegiToken !== null) {
      if (vm.newAirRegiToken === '') {
        generalSettingsService.runForFoundSetting(vm.settings, GeneralSetting.CODES.AIRREGI_INTEGRATION, function(
          airRegiIntegrationSetting,
        ) {
          airRegiIntegrationSetting.value = 0;
          vm.needRefresh = true;
          changedSettings.push(airRegiIntegrationSetting);
        });
      }
      vm.airReggieSetting.value = vm.newAirRegiToken;
      changedSettings.push(vm.airReggieSetting);
    }

    if (vm.newMenuMgntMinGuest !== null) {
      if (vm.newMenuMgntMinGuest === '') {
        generalSettingsService.runForFoundSetting(vm.settings, GeneralSetting.CODES.PRE_ORDER_MENU_ENABLED, function(
          menuMgntMinGuestSetting,
        ) {
          menuMgntMinGuestSetting.value = 0;
          vm.needRefresh = true;
          changedSettings.push(menuMgntMinGuestSetting);
        });
      }
      vm.menuMgntMinGuestSetting.value = vm.newMenuMgntMinGuest;
      changedSettings.push(vm.menuMgntMinGuestSetting);
    }

    if (vm.specialComBoxSetting) {
      if (vm.specialComBoxSetting.value === '') {
        generalSettingsService.runForFoundSetting(vm.settings, GeneralSetting.CODES.SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL, function(
          cummunicationBoxIntegration,
        ) {
          cummunicationBoxIntegration.value = 0;
          vm.needRefresh = true;
          changedSettings.push(cummunicationBoxIntegration);
        });
      }
      vm.originalSpecialComBoxSetting.value = vm.specialComBoxSetting.value;
      changedSettings.push(vm.originalSpecialComBoxSetting);
    }

    const diningPackagesEnabledSetting = changedSettings.find(
      setting => setting.settingAttributeId === SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_ENABLED,
    );
    if (diningPackagesEnabledSetting && !diningPackagesEnabledSetting.value && diningPackagesEnabledSetting.oldValue) {
      const diningPackageRequiredSetting = vm.settings.find(
        setting => setting.settingAttributeId === SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_REQUIRED,
      );
      diningPackageRequiredSetting.value = 0;
      changedSettings.push(diningPackageRequiredSetting);
    }

    return changedSettings;
  }

  function isDifferentFromOriginal(setting) {
    const settingToBeCreated = !setting.id;
    if (settingToBeCreated) {
      return true;
    }

    const original = UtilService.findElementById(vm.originalSettings, setting.id);

    //To make the comparison correct, we need to format the original value for min_leading_time
    if (setting.code === GeneralSetting.CODES.MIN_LEADING_TIME) {
      return original && formatMinutes(original.value) !== setting.value;
    }

    return original && original.value !== setting.value;
  }

  function addOverbookingSettingToSubmit(changedSettings, selectedAreaSettings, activeAreaSettings, overbookingSettings) {
    if (!overbookingSettings.length) {
      // .. add overbooking if missing
      changedSettings = changedSettings.concat(GeneralSetting.getByCode(GeneralSetting.CODES.OVERBOOKING, vm.settings));
    }
    return changedSettings.concat(selectedAreaSettings.concat(activeAreaSettings).filter(isUnique));
  }

  function isUnique(item, i, items) {
    return i === items.indexOf(item);
  }

  function resetOverbookingSetting(changedSettings, overbookingSettings) {
    const overbooking = GeneralSetting.getByCode(GeneralSetting.CODES.OVERBOOKING, vm.settings);

    if (overbookingSettings.length && overbookingSettings[0].value === 1) {
      overbookingSettings[0].oldValue = overbookingSettings[0].value;
      overbookingSettings[0].value = 0;
      GeneralSetting.spliceByCode(GeneralSetting.CODES.OVERBOOKING, changedSettings);
    } else if (overbooking.length && overbooking[0].value === 1) {
      overbooking[0].oldValue = overbooking[0].value;
      overbooking[0].value = 0;
      changedSettings = changedSettings.concat(overbooking);
    }

    return changedSettings;
  }

  function formatRequestBody(settings) {
    return { settings: settings.map(reduceSettingAttributes) };
  }

  function isSelectedOverbookingArea(setting) {
    return setting.code === GeneralSetting.CODES.OVERBOOKING_AREA && setting.value !== 0;
  }

  function reduceSettingAttributes(setting) {
    if (setting.code === GeneralSetting.CODES.OVERBOOKING_AREA) {
      return { code: setting.code, settingAttributeId: setting.settingAttributeId, value: setting.value };
    }

    return { id: setting.id, code: setting.code, settingAttributeId: setting.settingAttributeId, value: setting.value };
  }

  function displayUpdateSuccess() {
    NotificationService.success($translate.instant('settings.general.updated.success'));
  }

  function displayUpdateError(res) {
    if (res.data && res.data.errors) {
      NotificationService.error($translate.instant(res.data.errors[0].message));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/settings/generalSettings.controller.js